module.exports = __webpack_public_path__ + "static/ural-bank-a6c31b0a32f3b26f2c592611c07b39d2.svg";